type RoleShowProps = {
  role: string
}

export const RoleShow = ({ role }: RoleShowProps) => {
  return <span className="text-success fw-normal fs-6 d-flex align-items-center">{role}</span>
}
